import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Lock, RotateCcw } from "lucide-react";

export function OrderFlags({ order, onChange }) {
  const [f, setF] = useState({ blocked: !!order.blocked, blocked_reason: order.blocked_reason || "", rework: !!order.rework, rework_of: order.rework_of ?? "" });
  const [busy, setBusy] = useState(false);
  const save = async (patch) => {
    const next = { ...f, ...patch };
    setF(next); setBusy(true);
    try {
      const { data } = await api.patch(`/orders/${order.id}/flags`, { ...next, rework_of: next.rework && next.rework_of !== "" ? Number(next.rework_of) : null });
      onChange?.(data); toast.success("Salvo");
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="order-flags" className="grid grid-cols-1 md:grid-cols-2 gap-3">
      <div className={`rounded-xl border p-3 space-y-2 ${f.blocked ? "border-red-700 bg-red-950/30" : "border-zinc-800"}`}>
        <label className="flex items-center gap-2 text-sm font-bold text-zinc-100"><input data-testid="flag-blocked" type="checkbox" disabled={busy} checked={f.blocked} onChange={(e) => save({ blocked: e.target.checked })} /> <Lock className="h-4 w-4 text-red-400" /> OS travada</label>
        {f.blocked && <div className="flex gap-2"><Input data-testid="flag-blocked-reason" value={f.blocked_reason} onChange={(e) => setF((p) => ({ ...p, blocked_reason: e.target.value }))} placeholder="Motivo (aguardando peça, cliente…)" className="bg-zinc-900 border-zinc-800" />
          <Button data-testid="flag-blocked-save" size="sm" disabled={busy} onClick={() => save({})} className="bg-zinc-800">OK</Button></div>}
      </div>
      <div className={`rounded-xl border p-3 space-y-2 ${f.rework ? "border-orange-600 bg-orange-950/20" : "border-zinc-800"}`}>
        <label className="flex items-center gap-2 text-sm font-bold text-zinc-100"><input data-testid="flag-rework" type="checkbox" disabled={busy} checked={f.rework} onChange={(e) => save({ rework: e.target.checked })} /> <RotateCcw className="h-4 w-4 text-orange-400" /> Retrabalho</label>
        {f.rework && <div className="flex gap-2"><Input data-testid="flag-rework-of" type="number" value={f.rework_of} onChange={(e) => setF((p) => ({ ...p, rework_of: e.target.value }))} placeholder="Nº da OS original (opcional)" className="bg-zinc-900 border-zinc-800" />
          <Button data-testid="flag-rework-save" size="sm" disabled={busy} onClick={() => save({})} className="bg-zinc-800">OK</Button></div>}
      </div>
    </div>
  );
}
